module.exports = __webpack_public_path__ + "static/img/vtec.517400a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/wechat/vtec.png
// module id = tv7Y
// module chunks = 44